import apiReminderBuilder from "../../../api";

const extract = (res) => (res.status === "fulfilled" ? res.value?.data?.data || [] : []);

// Dropdown data of the domain event form: every active source (drafts too, with status and has_reference).
export const loadDomainEventDependencies = async () => {
  const [sourcesRes] = await Promise.allSettled([apiReminderBuilder.getSourceOptions()]);
  return { sources: extract(sourcesRes) };
};
